import { render, staticRenderFns } from "./in-the-media.vue?vue&type=template&id=5bb8c122&scoped=true&"
import script from "./in-the-media.vue?vue&type=script&lang=js&"
export * from "./in-the-media.vue?vue&type=script&lang=js&"
import style0 from "./in-the-media.vue?vue&type=style&index=0&id=5bb8c122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb8c122",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VHover,VImg,VRow,VSheet,VSpacer})
